package fr.frux.shared.domain.model

import fr.frux.core.common.entitlements.PremiumSource
import kotlin.time.Instant

/**
 * Statut Frux+ du compte courant (#456), sans type de transport (#109). Dérivé des droits lus par
 * `GET /auth/me`, jamais d'un DTO.
 */
sealed interface PremiumStatus {
    /** Rien n'a encore été lu pour la session courante. */
    data object Unknown : PremiumStatus

    /** Résolu sans Frux+ : anonyme, compte gratuit ou abonnement échu. */
    data object Free : PremiumStatus

    /** Frux+ actif. [expiresAt] est `null` pour un droit sans échéance. */
    data class Active(
        val expiresAt: Instant?,
        val source: PremiumSource,
    ) : PremiumStatus
}
